import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

// The same Back control in every container. Styles live in src/styles/modals.css.
const BackButton = ({ onClick, label = "Back", className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`modal-back ${className}`.trim()}
    aria-label={label}
  >
    <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
    <span>{label}</span>
  </button>
);

export default BackButton;
